import { storeToRefs } from 'pinia';
import { computed, inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { PricatService } from './pricat.service';

import { Icons } from '@/models/icons.enum';
import { useUserStore } from '@/stores/user';

import { useNewRelic } from '@/composables/useNewRelic';

export function usePricatDownload() {
  const { t } = useI18n();
  const $snotify = inject<any>('$snotify');
  const newRelic = useNewRelic();
  const { selectedAccountId } = storeToRefs(useUserStore());

  const pricatService = new PricatService();

  const downloadingPricat = ref(false);

  const getPricatIcon = computed(() => {
    return downloadingPricat.value ? Icons.LOADING : Icons.DOWNLOAD_ARROW_SIGN;
  });

  const fetchPricat = async (season: string) => {
    downloadingPricat.value = true;
    try {
      await pricatService.downloadPricat(selectedAccountId.value, season);
    } catch (err: any) {
      newRelic.noticeError('Error fetch pricat file', err);
      $snotify.warning(t('documentsCheckout.document_is_not_available'));
    }

    downloadingPricat.value = false;
  };

  return {
    downloadingPricat,
    getPricatIcon,
    fetchPricat,
  };
}
